import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";

const PositionsContext = createContext(null);

export const PositionsProvider = ({ children }) => {
  const { user } = useAuth();
  const [positions, setPositions] = useState([]);
  const reload = useCallback(() => api.get("/positions").then((r) => setPositions(r.data)), []);
  useEffect(() => {
    if (user) reload();
  }, [user, reload]);
  return <PositionsContext.Provider value={{ positions, reload }}>{children}</PositionsContext.Provider>;
};

export const usePositions = () => {
  const { positions, reload } = useContext(PositionsContext);
  const { lang } = useLang();
  const label = useCallback((key) => {
    const p = positions.find((x) => x.key === key);
    return p ? p[lang] || p.fr : key;
  }, [positions, lang]);
  return { positions, label, reload };
};

export const useFetch = (url, params) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => {
    if (!url) return Promise.resolve();
    return api.get(url, { params: JSON.parse(key) }).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [url, key]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { data, loading, reload, setData };
};
